import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import debounce from 'lodash.debounce';

import CardSlot from './CardSlot';
import EmptyCardSlot from './EmptyCardSlot';
import { Typography, MatchHeightProvider } from '@americanexpress/aqx-components';

// SELECTORS
import { getHeader, getSubHeader } from '../redux';

import styles from '../__styles__/desktopHeader.scss?modules';

const useIsAbove = ref => {
  const [isAbove, setIsAbove] = useState(true);
  const observerRef = useRef(null);
  const lastTimeDone = useRef(new Date());

  const callback = ([entry]) => {
    // next 5 lines is to remove the shaky effect
    const dtNow = new Date();
    if (dtNow.getTime() - lastTimeDone.current.getTime() < 600) {
      return;
    }
    lastTimeDone.current = dtNow;
    if (!entry.isIntersecting) {
      setIsAbove(false);
    } else if (entry.isIntersecting) {
      setIsAbove(true);
    }
  };

  const debouncedHandler = debounce(callback, 500);

  useEffect(() => {
    observerRef.current = new IntersectionObserver(debouncedHandler, {
      threshold: 1.0
    });
  }, []);

  useEffect(
    () => {
      observerRef.current.observe(ref.current);

      return () => {
        observerRef.current.disconnect();
      };
    },
    [ref]
  );

  return isAbove;
};

const DesktopHeader = ({ selectedCards, header, subHeader }) => {
  const ref = useRef(null);
  const isAbove = useIsAbove(ref);

  return (
    <div className={styles.container} ref={ref}>
      <div className={styles.leftContent}>
        <Typography
          className={styles.header}
          Component={`${header ? 'h1' : 'span'}`}
        >
          {header}
        </Typography>
        {isAbove && (
          <Typography className={styles.subHeader}>{subHeader}</Typography>
        )}
      </div>
      <MatchHeightProvider isResponsive={true}>
        <div className={styles.rightContent}>
          {selectedCards.map(
            (card, i) =>
              card ? (
                <CardSlot smallCardArt={!isAbove} card={card} key={i} />
              ) : (
                <EmptyCardSlot key={i} card={card} />
              )
          )}
        </div>
      </MatchHeightProvider>
    </div>
  );
};

const mapStateToProps = state => ({
  header: getHeader(state),
  subHeader: getSubHeader(state)
});

export default connect(mapStateToProps)(DesktopHeader);
